<template>
    <main class="professional-reviews" :aria-busy="loading ? 'true' : 'false'">
        <header class="reviews-header"><div><h1>{{ professionalLabel }}匿名评价</h1><p>按最新评价时间展示</p></div><button type="button" :disabled="loading || !validIdentity" @click="load(1)">刷新</button></header>
        <p v-if="!validIdentity" role="alert">专业身份无效，请从订单服务者卡片重新进入。</p>
        <template v-else>
            <section v-if="data" class="reviews-statistics" aria-label="专业统计"><dl>
                <div><dt>平均评分</dt><dd>{{ data.averageScore == null ? '暂无评价' : Number(data.averageScore).toFixed(1) + ' / 5' }}</dd></div>
                <div><dt>评价数</dt><dd>{{ data.reviewCount }}</dd></div>
                <div><dt>正常完成单数</dt><dd>{{ data.completedOrderCount }}</dd></div>
            </dl></section>
            <p v-if="loading" role="status">评价加载中…</p>
            <div v-else-if="error" class="reviews-feedback" role="alert"><p>评价加载失败，请稍后重试。</p><button type="button" @click="load(requestedPage)">重试</button></div>
            <template v-else-if="data">
                <div v-if="data.items && data.items.length" class="reviews-list"><ServiceReviewItem v-for="review in data.items" :key="review.reviewId" :review="review" @refresh="refreshImages" /></div>
                <p v-else class="reviews-feedback" role="status">暂无评价</p>
                <nav class="reviews-pagination" aria-label="评价分页">
                    <button type="button" :disabled="data.pageNo <= 1" @click="load(data.pageNo - 1)">上一页</button>
                    <span>第 {{ data.pageNo }} 页 · 共 {{ data.total }} 条</span>
                    <button type="button" :disabled="data.pageNo * data.pageSize >= data.total" @click="load(data.pageNo + 1)">下一页</button>
                </nav>
            </template>
        </template>
    </main>
</template>
<script>
import serviceReviews from '@/tool/serviceReviews';
import ServiceReviewItem from '@/components/photography/ServiceReviewItem.vue';

export default {
    name: 'ProfessionalReviews',
    components: { ServiceReviewItem },
    data: () => ({ data: null, loading: false, error: false, requestedPage: 1, generation: 0 }),
    computed: {
        professionalType() { return this.$route.params.professionalType; },
        professionalId() { return this.$route.params.professionalId; },
        validIdentity() { return ['1', '2'].includes(this.professionalType) && typeof this.professionalId === 'string' && /^[1-9]\d*$/.test(this.professionalId); },
        identity() { return this.professionalType + '/' + this.professionalId; },
        professionalLabel() { return this.professionalType === '2' ? '化妆师' : '摄影师'; },
    },
    watch: { identity: { immediate: true, handler() { this.load(1); } } },
    beforeDestroy() { this.generation += 1; },
    methods: {
        refreshImages() { return this.load(this.data ? this.data.pageNo : this.requestedPage); },
        async load(pageNo) {
            const generation = ++this.generation;
            this.data = null;
            this.error = false;
            this.loading = false;
            this.requestedPage = pageNo;
            if (!this.validIdentity) return;
            this.loading = true;
            try {
                const data = await serviceReviews.list(this.professionalType, this.professionalId, pageNo);
                if (generation === this.generation) this.data = data;
            } catch (error) {
                if (generation === this.generation) this.error = true;
            } finally {
                if (generation === this.generation) this.loading = false;
            }
        },
    },
};
</script>
<style scoped>
.professional-reviews { box-sizing:border-box; width:100%; max-width:1000px; margin:24px auto; padding:24px; color:#51455b; background:#faf8fb; border-radius:12px; font-size:14px; line-height:1.6; overflow-wrap:anywhere; }
.reviews-header { display:flex; justify-content:space-between; align-items:center; gap:16px; margin-bottom:20px; }.reviews-header h1 { margin:0; font-size:22px; color:#332d49; }.reviews-header p { margin:6px 0 0; color:#66596f; }
button { flex-shrink:0; min-height:44px; padding:8px 16px; border:1px solid #c8b6d5; border-radius:7px; background:#fff; color:#624385; cursor:pointer; font:inherit; }button:hover:not(:disabled) { background:#eee8f0; }button:focus-visible { outline:3px solid #76528e; outline-offset:3px; }button:disabled { cursor:default; opacity:.5; }
.reviews-statistics { padding:18px; margin-bottom:20px; border:1px solid #eee7f0; border-radius:10px; background:#fff; }.reviews-statistics dl { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:12px; margin:0; }.reviews-statistics dt { font-size:13px; color:#66596f; }.reviews-statistics dd { margin:5px 0 0; font-size:18px; font-weight:700; color:#332d49; }
.reviews-list { display:grid; gap:16px; }.reviews-feedback { padding:24px 0; text-align:center; }.reviews-pagination { display:flex; justify-content:center; align-items:center; flex-wrap:wrap; gap:14px; margin-top:24px; }
@media(max-width:600px) { .professional-reviews { margin:0 auto; padding:16px; border-radius:0; }.reviews-header h1 { font-size:20px; }.reviews-statistics { padding:14px; }.reviews-statistics dd { font-size:16px; }.reviews-pagination { gap:10px; } }
</style>
